// extracted by mini-css-extract-plugin
export default {"wrapper__opened":"Support_wrapper__opened__49Oyo","bellIcon":"Support_bellIcon__7FE1u","settingsIcon":"Support_settingsIcon__UDVcX","questionIcon":"Support_questionIcon__gDsFD"};